import React from 'react'

export default function InputTile({ children }: React.PropsWithChildren) {
  return (
    <div className="flex flex-col gap-7 rounded bg-white p-6">{children}</div>
  )
}
